import React from 'react';
import spogenLogo from '#/assets/spogen.ai_logo_nega_rgb.svg';
import smartLogo from '#/assets/smart_assistant.svg';
import { useMsal } from '@azure/msal-react';

import './login-modal.css';

const LoginModal: React.FC = () => {
  const { instance } = useMsal();

  const navigateToLogin = () => {
    instance.loginRedirect();
  };

  return (
    <div className="modal-fullscreen">
      <div className="modal-content">
        <div className="branding-group">
          <img src={smartLogo} className="smart-logo" />
          <div className="powered-row">
            <span className="powered-text">By</span>
            <img src={spogenLogo} className="spogen-logo" />
          </div>
        </div>
        <button className="loginButton" onClick={navigateToLogin}>Login</button>
      </div>
    </div>
  );
};

export default LoginModal;
